import React, { useRef, useEffect } from 'react';
import Navbar from '../../components/common/Header/Navbar';
import bannerimg from '../../assets/Recharge_api_images/travel_banner.png'; 
import missionvissonimg from '../../assets/Recharge_api_images/travel_api_img.png'; 
import "../../styles/recharge_api.css";

// Icons (Replace with actual PNG/SVG paths)

import flightbook from '../../assets/Recharge_api_images/flightbook-icon.png';
import busticket from '../../assets/Recharge_api_images/busticket-icon.png';
import trainticket from '../../assets/Recharge_api_images/trainticket-icon.png';
import hotelbook from '../../assets/Recharge_api_images/hotelbook-icon.png';
import carrent from '../../assets/Recharge_api_images/carrent-icon.png';
import holiday from '../../assets/Recharge_api_images/holiday-icon.png';
import benefitBanner from '../../assets/Recharge_api_images/benefit_banner.png';
import integrationProcessImage from "../../assets/Recharge_api_images/integration_background.png";


import securityMeasuresImage from "../../assets/Recharge_api_images/security1.png";
import securitysecurityMeasuresImage from "../../assets/Recharge_api_images/security2.png";


const TravelBookingApis = () => {
  const featuresCarouselRef = useRef(null);
  const featuresIndicatorsRef = useRef(null);

  // Mobile Carousel Effect (Same as BBPS)
  useEffect(() => {
    const carousel = featuresCarouselRef.current;
    if (!carousel || window.innerWidth > 768) return;

    const indicators = featuresIndicatorsRef.current?.querySelectorAll('.indicator');
    const slides = carousel.querySelectorAll('.feature-slide');
    let currentSlide = 0;

    const updateIndicators = () => {
      indicators?.forEach((indicator, index) => {
        indicator.classList.toggle('active', index === currentSlide);
      });
    };

    const goToSlide = (slideIndex) => {
      currentSlide = slideIndex;
      const slideWidth = slides[0].offsetWidth;
      carousel.scrollTo({ left: slideIndex * slideWidth, behavior: 'smooth' });
      updateIndicators();
    };

    indicators?.forEach((indicator, index) => {
      indicator.addEventListener('click', () => goToSlide(index));
    });

    const handleScroll = () => {
      const slideWidth = slides[0].offsetWidth;
      const scrollLeft = carousel.scrollLeft;
      const newSlide = Math.round(scrollLeft / slideWidth);
      if (newSlide !== currentSlide) {
        currentSlide = newSlide;
        updateIndicators();
      }
    };

    carousel.addEventListener('scroll', handleScroll);
    updateIndicators();

    return () => {
      indicators?.forEach((indicator, index) => {
        indicator.removeEventListener('click', () => goToSlide(index));
      });
      carousel.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const FeatureBox = ({ title, description, className = '' }) => (
    <div className={`feature-box feature-box-secondary ${className}`}>
      <h4 className="feature-title font-lato text-[20px] font-bold">{title}</h4>
      <p className="feature-description font-lato text-[17px] font-normal leading-[26px]">{description}</p>
    </div>
  );

  const BenefitCard = ({ icon, title, description }) => (
    <div className="benefit-card group p-6 rounded-xl shadow-lg transition-all duration-300 cursor-pointer">
      <div className="card-icon-container mb-4">
        <img src={icon} alt={title} className="card-icon w-12 h-12" />
      </div>
      <h3 className="card-title text-gray-900 text-xl font-semibold mb-2">{title}</h3>
      <p className="card-description text-[#6E6E6E] font-lato text-[17px] font-normal leading-[26px]">{description}</p>
    </div>
  );

  return (
    <>
      {/* Banner Section */}
      <div className="relative w-full h-[300px] md:h-auto min-h-52">
        <img src={bannerimg} alt="Travel APIs Banner" className="w-full h-full object-cover" />
        <div className="banner-content absolute inset-0 flex flex-col items-center justify-center px-6 py-12">
          <h1 className="text-white text-4xl md:text-6xl lg:text-[80px] font-normal font-goldman text-center leading-tight md:leading-normal">
            TRAVEL BOOKING API
          </h1>
          <p className="text-[#D9D9D9] text-base md:text-xl lg:text-[22px] text-center max-w-2xl font-dmsans font-normal leading-normal tracking-[0.22px] mt-2">
            Simplify travel bookings with seamless API integrations for flights, buses, trains, hotels, and more all from a single platform.
          </p>
        </div>
      </div>

      {/* Core Section: 3 Feature Cards + Illustration */}
      <section className="recharge-api-section">
        <div className="content-container">
          <div className="text-and-features-column">
            <p className="section-tag">OUR CORE API SERVICES</p>
            <h1 className="main-title">
              Power Your Travel Platform <br /> With Reliable APIs
            </h1>
            <p className="main-description font-lato text-[17px] font-normal leading-[26px]">
              API Galaxy’s Travel APIs connect your app or platform to a wide network of travel providers, enabling instant bookings and real-time availability. Whether you’re building a travel startup or scaling an existing portal, our APIs make integration effortless and performance unmatched.
            </p>

            {/* Desktop Grid */}
            <div className="features-grid hidden md:grid">
              <FeatureBox
                title="Instant Booking"
                description="Book flights, buses, trains, and hotels in real-time with instant confirmation and live seat availability through our high-speed Travel APIs."
                className="feature-box-2-of-5"
              />
              <FeatureBox
                title="Multiple Travel Categories"
                description="From flight and bus bookings to car rentals and holiday packages access multiple travel services through a single integration."
                className="feature-box-2-of-5"
              />
              <FeatureBox
                title="Global Connectivity"
                description="Connect your platform to a network of domestic and international travel providers for seamless multi-destination booking experiences."
                className="feature-box-3-of-5"
              />
              <FeatureBox
                title="Dynamic Pricing & Offers"
                description="Deliver competitive fares and exclusive deals with automatic price updates and real-time promotional integrations."
                className="feature-box-3-of-5"
              />
            </div>

            {/* Mobile Carousel */}
            <div className="md:hidden carousel-container">
              <div className="features-grid" ref={featuresCarouselRef}>
                <div className="feature-slide">
                  <FeatureBox title="Flight Booking API" description="Real-time flight search, availability, and booking." />
                </div>
                <div className="feature-slide">
                  <FeatureBox title="Hotel Booking API" description="Instant access to global hotel inventories and pricing." />
                </div>
                <div className="feature-slide">
                  <FeatureBox title="Bus & Train API" description="Simplify multi-modal transport integration in your platform." />
                </div>
                <div className="feature-slide">
                <FeatureBox title="One API, All Travel" description="Connect flights, hotels, and ground transport in a single integration."/>
            </div>
              </div>
              <div className="carousel-indicators" ref={featuresIndicatorsRef}>
                <span className="indicator" data-slide="0"></span>
                <span className="indicator" data-slide="1"></span>
                <span className="indicator" data-slide="2"></span>
              </div>
            </div>
          </div>

          <div className="illustration-column flex flex-col items-start ml-24">
            <img src={missionvissonimg} alt="Travel APIs Illustration" className="recharge-illustration" />
          </div>
        </div>
      </section>

      {/* Why Choose Us - Benefits Grid */}
      <section className="benefits-section relative overflow-hidden">
        <div
          className="absolute top-0 left-0 w-full h-[400px] z-0"
          style={{ backgroundImage: `url(${benefitBanner})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        ></div>
        <div className="benefits-header-content-bg">
          <div className="benefits-header-overlay"></div>
        </div>

        <div className="benefits-header-content">
          <div className="header-text-container">
            <p className="header-tag">WHY CHOOSE OUR APIS</p>
            <h2 className="header-title">Maximize Reach, Efficiency, and Revenue</h2>
          </div>
          <div className="header-description-container">
            <p className="header-description text-justify">
              Scale your travel business with global inventory, real-time pricing, and enterprise-grade reliability.
            </p>
          </div>
        </div>

        <div className="benefits-cards-grid-container">
          <div className="benefits-cards-grid">
            <BenefitCard icon={flightbook} title="Flight Booking" description="Real-time flight availability, pricing, and ticketing through global and domestic carriers." />
            <BenefitCard icon={busticket} title="Bus Ticket" description="Connect with major bus operators across India with instant seat availability and booking confirmation." />
            <BenefitCard icon={trainticket} title="Train Ticket" description="Simplified integration with IRCTC-powered services for hassle-free railway reservations." />
            <BenefitCard icon={hotelbook} title="Hotel Booking" description="Access thousands of hotels worldwide with dynamic pricing and live availability." />
            <BenefitCard icon={carrent} title="Car Rental" description="Integrate intercity and local cab networks with instant booking and tracking options." />
            <BenefitCard icon={holiday} title="Holiday Packages" description="Offer customizable travel experiences and curated holiday packages through a single API." />

          </div>
        </div>
      </section>

      {/* Security & Reliability */}
       <section
              className="relative py-16 px-4 md:px-8 lg:px-16 overflow-hidden"
              style={{
                backgroundImage: `url(${integrationProcessImage})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
              }}
            >
              <div className="max-w-7xl mx-auto">
                {/* --- Top Section Header and Title --- */}
                <span className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]">
                  Integrate Faster. Operate Safer. 
                </span>
                <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-12 leading-tight">
                  Built for the Digital <br />
                   Travel Galaxy
                </h1>
      
      
                <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">
                  <div className="relative w-full lg:w-1/2 min-h-[300px]">
                    <div className="w-full h-full absolute top-0 left-0">
                      <img
                        src={securityMeasuresImage}
                        alt="Integration Process"
                        className="w-[90%] h-full object-cover rounded-xl shadow-2xl"
                      />
                    </div>
      
                    <div
                      className="absolute top-1/4 right-0 bg-[#F9F9F9] rounded-xl p-6 w-11/12 md:w-3/4 lg:w-[350px]
                   flex flex-col items-start gap-1 flex-1"
                    >
                      <h3 className="text-xl font-bold text-gray-800 mb-2">
                        Integration Process
                      </h3>
                      <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                        Easily integrate our Travel APIs with your platform using our developer-friendly documentation and ready-to-use endpoints.
                      </p>
                      <a
                        href="#"
                        className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150"
                      >
                        SEE MORE <span className="ml-2">→</span>
                      </a>
                    </div>
                  </div>
      
                  {/* Right Side: Checklist */}
                  <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
                    <ul className="space-y-6">
                      {[
                        // "Sign Up - Get API access and credentials.",
                        "Sign Up & Get API Keys - Register and instantly access your secure API credentials.",
                        "Connect Travel Services - Integrate flight, bus, train, and hotel APIs with simple REST calls.",
                        // "Testing - Run test transactions in a sandbox environment.",
                        "Start Booking in Real-Time - Fetch live availability, fares, and confirm bookings instantly.",
                      ].map((item, index) => (
                        <li key={index} className="flex items-start">
                          <span className="text-[#00AFEF]  font-bold text-lg mr-3 mt-1">
                            ✓
                          </span>
                          <p className="text-lg text-gray-700">{item}</p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
      
                {/* ------------------------------------- */}
                {/* --- 2. Security Measures Section --- */}
                {/* ------------------------------------- */}
      
                <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">
                  <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
                    <span className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]">
                      Integration & Security
                    </span>
                    {/* Removed <br></br> */}
      
                    {/* Added mt-4 or mb-4 to the list for separation */}
                    <ul className="space-y-6 mt-4">
                      {[
                        // "Sign Up - Get API access and credentials.",
                        "Data Encryption – Safeguards all booking and payment information with end-to-end encryption.",
                        "Multi-Layer Authentication – Ensures every API request is secure and authorized. ",
                        "Real-Time Monitoring:  – Tracks API performance and booking activity 24×7 for uninterrupted service.",
                      ].map((item, index) => (
                        <li key={index} className="flex items-start">
                          <span className="text-[#00AFEF] font-bold text-lg mr-3 mt-1">
                            ✓
                          </span>
                          <p className="text-lg text-gray-700">{item}</p>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="relative w-full lg:w-1/2 min-h-[300px]">
                    <div className="w-full h-full absolute top-0 left-0">
                      <img
                        src={securitysecurityMeasuresImage}
                        alt="Integration Process"
                        className="w-[90%] h-full object-cover rounded-xl shadow-2xl"
                      />
                    </div>
      
                    <div className="absolute top-1/4 right-0 bg-[#F9F9F9] p-6 rounded-xl  w-11/12 md:w-3/4 lg:w-[350px]">
                      <h3 className="text-xl font-bold text-gray-800 mb-2">
                        Security Features
                      </h3>
                      <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                         Our robust security framework ensures the highest level of data protection and system integrity. 
                      </p>
                      <a
                        href="#"
                        className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150"
                      >
                        SEE MORE <span className="ml-2">→</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
    </>
  );
};

export default TravelBookingApis;